import { gql } from '@apollo/client'

export default gql`
  fragment LatestContractDTO on LatestContractDTO {
    id
    currencyForPayments
    validFrom
    validTo
    updatesRestrictedTo
    cancellationType
    cancellationFrom
    updatesRestrictedTo
    cancellationTo
    flexibleBenefit
    legalEntity {
      name
      country
    }
    annualSalary {
      amount
      isTentative
      currency
    }
    targetBonus {
      amount
      currency
    }
    contractType {
      typeOfContract
    }
    employeeLevel {
      level
      isTentative
    }
    hasNationalContract
    nationalContractLevel {
      type
      level
    }
    nationalContractReferenceLevel {
      description
      levels {
        level
        minSalary
        selectable
        displayOrder
      }
    }
    leaveEntitlement {
      amount
    }
    companyCar {
      deduction
      type
      currency
    }
    executedPayments {
      amount
      referenceYear
      paymentDate
      type
      currency
    }
    isDeductionEnabled
    isMonthlySalaryDisplayed
    monthlySalaryMonthsInYear
    contractGovernmentJobTitle {
      id
      governmentJobTitle {
        id
        hiringOffice {
          id
          code
        }
        department
        title
        level
        monthlySalaryMinimum
        monthlySalaryMaximum
        currency
        fromDate
        toDate
        sortOrder
      }
      fromDate
      toDate
    }
  }
`
